import axios from 'axios';
import { getAuthToken } from '../utils/sessionAuth.js';

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/classes`;

const authHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const jsonHeaders = () => ({ ...authHeaders(), 'Content-Type': 'application/json' });

const listClasses = async () => {
  const { data } = await axios.get(API_URL, { headers: authHeaders() });
  return data;
};

const getClass = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}`, { headers: authHeaders() });
  return data;
};

const createClass = async (payload) => {
  const { data } = await axios.post(API_URL, payload, { headers: jsonHeaders() });
  return data;
};

const updateClass = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/${id}`, payload, { headers: jsonHeaders() });
  return data;
};

const deleteClass = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${id}`, { headers: authHeaders() });
  return data;
};

const getClassroom = async () => {
  const { data } = await axios.get(`${API_URL}/classroom`, { headers: authHeaders() });
  return data;
};

const listLessonTemplates = async () => {
  const { data } = await axios.get(`${API_URL}/lesson-templates`, { headers: authHeaders() });
  return data;
};

const createLessonTemplate = async (payload) => {
  const { data } = await axios.post(`${API_URL}/lesson-templates`, payload, { headers: jsonHeaders() });
  return data;
};

const updateLessonTemplate = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/lesson-templates/${id}`, payload, { headers: jsonHeaders() });
  return data;
};

const deleteLessonTemplate = async (id) => {
  const { data } = await axios.delete(`${API_URL}/lesson-templates/${id}`, { headers: authHeaders() });
  return data;
};

const pushEducation = async (id) => {
  const { data } = await axios.post(`${API_URL}/${id}/education/push`, {}, { headers: jsonHeaders() });
  return data;
};

const removeEducation = async (id) => {
  const { data } = await axios.post(`${API_URL}/${id}/education/remove`, {}, { headers: jsonHeaders() });
  return data;
};

const startLesson = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/lessons/start`, payload, { headers: jsonHeaders() });
  return data;
};

const endLesson = async (id) => {
  const { data } = await axios.post(`${API_URL}/${id}/lessons/end`, {}, { headers: jsonHeaders() });
  return data;
};

const getActiveLesson = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}/lessons/active`, { headers: authHeaders() });
  return data;
};

const applyControls = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/control`, payload, { headers: jsonHeaders() });
  return data;
};

const refreshInventory = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/control/inventory`, payload, { headers: jsonHeaders() });
  return data;
};

const lockDevices = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/control/lock`, payload, { headers: jsonHeaders() });
  return data;
};

const requestApp = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/control/app-request`, payload, { headers: jsonHeaders() });
  return data;
};

const installApps = async (id, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/${id}/control/install-apps`, payload, { headers: jsonHeaders() });
  return data;
};

const listInstalledApps = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}/control/installed-apps`, { headers: authHeaders() });
  return data;
};

const listAppRequests = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}/control/app-requests`, { headers: authHeaders() });
  return data;
};

const listClassDevices = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}/devices`, { headers: authHeaders() });
  return data;
};

const assignUser = async (payload) => {
  const { data } = await axios.post(`${API_URL}/assign-user`, payload, { headers: jsonHeaders() });
  return data;
};

const unassignUser = async (payload) => {
  const { data } = await axios.post(`${API_URL}/unassign-user`, payload, { headers: jsonHeaders() });
  return data;
};

const schoolClassService = {
  listClasses,
  getClass,
  createClass,
  updateClass,
  deleteClass,
  getClassroom,
  listLessonTemplates,
  createLessonTemplate,
  updateLessonTemplate,
  deleteLessonTemplate,
  pushEducation,
  removeEducation,
  startLesson,
  endLesson,
  getActiveLesson,
  applyControls,
  refreshInventory,
  lockDevices,
  requestApp,
  installApps,
  listInstalledApps,
  listAppRequests,
  listClassDevices,
  assignUser,
  unassignUser,
};

export default schoolClassService;
